module.exports = __webpack_public_path__ + "img/100-secure.6f23a9c.png";